import { useCallback } from 'react';

import { VisitHistory } from '@dreryk/egabinet-visit-frontend-api';

import {
   InfiniteList,
   InfiniteListData,
   InfiniteListItemKeyGenerator,
   InfiniteListItemRenderer,
   InfiniteListLoadMoreAvailable,
   InfiniteListLoadMoreFunction,
} from '@dreryk/react-components';

import { isVisitHistoryWithConfidentialDetails } from '~libs.shared.visit';

import { visitHistoryTranslationKeys } from '../translations';

import { VisitHistoryInfiniteListPlaceholder } from './VisitHistoryInfiniteListPlaceholder';
import { VisitHistoryPanel } from './VisitHistoryPanel';
import { VisitHistoryWithoutConfidentialDetailsPanel } from './VisitHistoryWithoutConfidentialDetailsPanel';

type VisitHistoryListProps = {
   readonly patientId: number;
   readonly data: InfiniteListData<VisitHistory>;
   readonly onLoadMore: InfiniteListLoadMoreFunction;
   readonly loadMoreAvailable: InfiniteListLoadMoreAvailable;
};

const visitHistoryInfiniteListItemKeyGenerator: InfiniteListItemKeyGenerator<VisitHistory> = (visitHistory) =>
   visitHistory.id;

export const VisitHistoryInfiniteList = (props: VisitHistoryListProps): JSX.Element => {
   const visitHistoryInfiniteListItemRenderer = useCallback<InfiniteListItemRenderer<VisitHistory>>(
      (visitHistory) =>
         isVisitHistoryWithConfidentialDetails(visitHistory) ? (
            <VisitHistoryPanel visitHistory={visitHistory} patientId={props.patientId} />
         ) : (
            <VisitHistoryWithoutConfidentialDetailsPanel visitHistory={visitHistory} />
         ),
      [props.patientId]
   );

   return (
      <InfiniteList<VisitHistory>
         testId={'visitHistory'}
         data={props.data}
         onLoadMore={props.onLoadMore}
         loadMoreLabel={visitHistoryTranslationKeys.loadOlderVisits}
         noMoreItemsLabel={visitHistoryTranslationKeys.alreadyDisplayingAllVisits}
         loadMoreAvailable={props.loadMoreAvailable}
         renderer={visitHistoryInfiniteListItemRenderer}
         itemKeyGenerator={visitHistoryInfiniteListItemKeyGenerator}
         noDataPlaceholder={<VisitHistoryInfiniteListPlaceholder patientId={props.patientId} />}
         gap={40}
      />
   );
};
